var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMilantexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.355419 0 0 .355419 9.01233 -183.043)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 540.362)",
    d: "m483.844-25.3438-227.875 23.9375 13.4062 1.40625h217.125zm-410.344 46.9688-45.4688 432.625 88.375 9.28125 32.5312-309.312 41.2188 317.094 74.875 7.84375 103.719-301.844-32.5 309.344 87.1875 9.15625 22.7812-2.375 44.9688-427.906-154.781-16.25-77.375 224.156-31.5625-235.625zm-73.5 3.875-25.3438 2.65625 23.9375 227.875 1.40625-13.4062zm513.406 230.469-1.40625 13.4062v217.125l25.3438-2.65625zm-487.906 256.031 2.65625 25.3438 227.875-23.9375-13.4062-1.40625z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.1617 515.005 509.195 53.5186-53.5186 509.195-509.195-53.5186z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 540.362v242.625l25.5-242.625zm269.375 0 242.625 25.5v-25.5zm242.625 269.375-25.5 242.625h25.5zm-512 217.125v25.5h242.625z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537.359 568.527-53.5186 509.196-509.195-53.5186 53.5186-509.196zm-54.1163 36.5435-153.964-16.1823-75.8956 224.327-27.0685-235.149-152.815-16.0614-45.4699 432.617 103.524 10.8807 32.5117-309.328 36.7008 316.602 62.9346 6.6147 104.273-301.785-32.5117 309.328 102.312 10.7531z",
    fill: "#bd0b0c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilantexLogo);
export default __webpack_public_path__ + "static/media/milantex-logo.f6614bd73860af15491b69c3ef45f7c0.svg";
export { ForwardRef as ReactComponent };